import React from 'react'
import { useTranslation } from 'i18n'
import WistiaEmbed from 'steps/video/WistiaEmbed'
import PlaceholderImage from 'components/PlaceholderImage'

import OptionalDropdownButton from 'steps/grocery/components/OptionalDropdownButton'

export const VideoComponent = ({
  videoIDs,
  onEvent,
  quizId,
  quizHeadline
}) => {
  let videoId = videoIDs[0]
  if (!videoId) return null
  const onVideoComponentLoad = () => {}

  const handleVideoViewed = () => {}

  const handleVideoPlayed = (videoId, videoName) => {
    onEvent('step_interaction_pq_embedded_video_play', {
      result_id: videoId,
      result: videoName,
      context_id: quizId, // TODO: context here should be the quiz or the quiz result?
      context: quizHeadline,
    })
  }

  const handleVideoWatched = (videoId, videoName) => {
    onEvent('step_interaction_pq_embedded_video_complete', {
      result_id: videoId,
      result: videoName,
      context_id: quizId, // TODO: context here should be the quiz or the quiz result?
      context: quizHeadline,
    })
  }

  return (
    <div className="quiz__answer-image-container quiz__answer-video-container">
    
      <WistiaEmbed
        onLoaded={onVideoComponentLoad}
        videoIDs={videoIDs}
        handleVideoViewed={handleVideoViewed}
        handleVideoPlayed={handleVideoPlayed}
        handleVideoWatched={handleVideoWatched}
        autoPlay={false}
      />
    
    </div>
  )
}

export const ImageComponent = ({
  image,
  className = 'quiz__answer-image-container',
  imageClassName = 'quiz__answer-image',
}) => {
  if (!image) return null
  return (
    <div className={className}>
      <div className={imageClassName}>
        <PlaceholderImage
          src={`${process.env.SITE_ASSET_URL}/${image.id}`}
          alt={image.altAttribute}
          width={745}
          height={408}
        />
      </div>
    </div>
  )
}
export const ResultActions = ({
  link,
  linkTitle,
  id,
  title,
  quizId,
  quizHeadline,
  onEvent,
  dropdownButtons,
  className,
  // puck (BR-5451): ShopButton styling mined by the step container
  shopButtonClassName = '',
  shopButtonStyle = undefined,
  shopButtonOverlayStyle = undefined,
}) => {
  const { t } = useTranslation('personalityQuiz')

  return (
  <div className={className}>
    {link && (
      <div className="quiz__answer-btn">
        <a
          href={link}
          className={`shop-button ${shopButtonClassName}`}
          style={shopButtonStyle}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            onEvent('step_interaction_pq_result_click', {
              result_id: id,
              result: title,
              context_id: quizId,
              context: quizHeadline,
            })
          }}
        >
          {shopButtonOverlayStyle && (
            <span aria-hidden style={shopButtonOverlayStyle} />
          )}
          {linkTitle || t('addToCart')}
        </a>
      </div>
    )}
    {dropdownButtons && (
      <div className="result-multibuttons">
        {dropdownButtons.map((dropdownButton, i) => (
          <OptionalDropdownButton
            key={i}
            id={dropdownButton.id}
            label={dropdownButton.label}
            links={dropdownButton.links}
            onLinkClick={(linkId, label, url) => {
              onEvent('step_interaction_pq_button_click', {
                result_id: linkId,
                result: label + ' | ' + url,
                context_id: id,
                context: title,
              })
            }}
          />
        ))}
      </div>
    )}
  </div>
  )
}
